import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import {
  Eye as FiEye,
  Pencil as FiPencil,
  Trash3 as FiTrash2,
  ArrowRightCircle as FiConvert,
  ThreeDotsVertical as FiMoreVertical,
} from 'react-bootstrap-icons';
import type { Quote } from '../../models/quote';
import styles from './Quotations.module.scss';

const popperConfig = {
  strategy: 'fixed' as const,
  modifiers: [
    { name: 'offset', options: { offset: [0, 4] } },
    {
      name: 'preventOverflow',
      options: {
        boundary: 'viewport',
        altBoundary: true,
        padding: 8,
      },
    },
    {
      name: 'flip',
      options: {
        fallbackPlacements: [
          'top-end',
          'bottom-end',
          'top-start',
          'bottom-start',
        ],
      },
    },
  ],
};

export interface QuotationRowActionsProps {
  quote: Quote;
  layout?: 'table' | 'mobile';
  canWrite?: boolean;
  onView: (quote: Quote) => void;
  onEdit: (quote: Quote) => void;
  onConvert: (quote: Quote) => void;
  onDelete: (quote: Quote) => void;
}

const QuotationRowActions: React.FC<QuotationRowActionsProps> = ({
  quote,
  layout = 'table',
  canWrite = true,
  onView,
  onEdit,
  onConvert,
  onDelete,
}) => {
  if (layout === 'mobile') {
    return (
      <div className={styles.actionsGroup}>
        <Button size="sm" variant="outline-primary" onClick={() => onView(quote)}>
          Ver
        </Button>
        {canWrite ? (
          <>
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => onEdit(quote)}
            >
              Editar
            </Button>
            <Button size="sm" variant="success" onClick={() => onConvert(quote)}>
              A venta
            </Button>
            <Button
              size="sm"
              variant="outline-danger"
              onClick={() => onDelete(quote)}
            >
              Eliminar
            </Button>
          </>
        ) : null}
      </div>
    );
  }

  return (
    <Dropdown className={styles.actionsDropdown} align="end">
      <Dropdown.Toggle
        variant="outline-secondary"
        size="sm"
        id={`quote-actions-${quote.id}`}
        className="d-inline-flex align-items-center"
      >
        <FiMoreVertical />
      </Dropdown.Toggle>
      <Dropdown.Menu popperConfig={popperConfig} renderOnMount>
        <Dropdown.Item onClick={() => onView(quote)}>
          <FiEye className="me-2" /> Ver
        </Dropdown.Item>
        {canWrite ? (
          <>
            <Dropdown.Item onClick={() => onEdit(quote)}>
              <FiPencil className="me-2" /> Editar
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onConvert(quote)}>
              <FiConvert className="me-2" /> Convertir a venta
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              className="text-danger"
              onClick={() => onDelete(quote)}
            >
              <FiTrash2 className="me-2" /> Eliminar
            </Dropdown.Item>
          </>
        ) : null}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default QuotationRowActions;
